import { render, staticRenderFns } from "./FolderIcon.vue?vue&type=template&id=e507f9f4&scoped=true"
import script from "./FolderIcon.vue?vue&type=script&lang=js"
export * from "./FolderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e507f9f4",
  null
  
)

export default component.exports